import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FileService } from '../shared/services/file.service';

export interface DocumentFilters {
  page?: number;
  size?: number;
  unitId?: string;
  documentName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  protected http = inject(HttpClient);
  protected fileService = inject(FileService);
  protected apiUrl = `${environment.basePath}/api/documents`;

  getDocuments(filters: DocumentFilters): Observable<any> {
    const params: any = {
      page: filters.page,
      size: filters.size
    };

    if (filters.unitId) {
      params.unitId = filters.unitId;
    }

    if (filters.documentName) {
      params.query = filters.documentName;
    }

    return this.http.get(this.apiUrl, { params });
  }

  getDocumentById(id: string): Observable<any> {
    return this.http.get(`${environment.basePath}/api/documents/${id}`);
  }

  uploadDocument(file: File, unitId?: string | null, purpose?: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    let params = new HttpParams();

    if (unitId) {
      params = params.set('unitId', unitId);
    }

    if (purpose) {
      params = params.set('purpose', purpose);
    }

    return this.http.post(this.apiUrl, formData, {params});
  }

  updateDocument(id: string, data: { name: string; purpose: string }): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, data);
  }

  getDownloadUrl(doc: any): string {
    const mediaId = doc?.media?.id || doc?.mediaId;
    const filename = doc?.media?.filename || doc?.documentName || doc?.fileName;

    if (!mediaId || !filename) {
      throw new Error('Document does not have media information');
    }

    return this.fileService.getPublicUrl(mediaId, filename);
  }

  downloadDocument(doc: any): Observable<Blob> {
    const mediaId = doc?.media?.id || doc?.mediaId;
    const filename = doc?.media?.filename || doc?.documentName || doc?.fileName;

    if (!mediaId || !filename) {
      throw new Error('Document does not have media information');
    }

    return this.fileService.downloadFile(mediaId, filename);
  }

  deleteDocument(documentId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${documentId}`);
  }
}